import { SelectInputData } from "@src/components/deprecated/SelectInputField/SelectInputField";
import { PropertyData } from "to-be-removed/LocalData/Property/PropertyData";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { LocalData } from "../../LocalData";
import { FirebaseDataSelectField, FirebaseDataSelectFieldOption } from "../Generic/FirebaseDataSelectField";

export class FirebaseDataPropertyField<FirebaseDataType extends DataObjectType> extends FirebaseDataSelectField<PropertyData, FirebaseDataType> {
  override encode = (value: PropertyData) => value.id;

  override convertValueToSelectInput(value: PropertyData): SelectInputData {
    return new SelectInputData(value.id, value.name);
  }
  getValueForKey(key: string): PropertyData | undefined {
    return LocalData.currentUser.properties.find((p) => p.id === key);
  }
  getOptions(): FirebaseDataSelectFieldOption[] {
    return LocalData.currentUser.properties
      .filter((property) => !property.archived)
      .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
      .map((property) => {
        return {
          key: property.id,
          label: property.name,
        };
      });
  }
  getReadableStringRepresentation(value: PropertyData): string {
    return value.name;
  }

  override isValueValid = (value: any): boolean => {
    return value instanceof PropertyData;
  };
}

